export default "__VITE_ASSET__CRzpt0gM__"